import React,{useState,useEffect,useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calender from '../assets/images/calendar.png';
//import pluscircle from '../assets/images/plus-circle.png';
import { Circles } from 'react-loader-spinner';
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../messageBox/customSweetAlert';
import axios from 'axios';
import { ADD_DRIVER_URI,GET_STATE_URI,GET_PASSENGER_LIST } from '../constant'; 
import { InputMask } from "primereact/inputmask";
import SaveButton  from '../components/buttons/SaveButton';
import CancelButton from '../components/buttons/CancelButton'
import {currentDateFormat,restrictZipInput} from "../utils";

import ConfirmPasswordNormal from '../components/ConfirmPasswordNormal';
import { useNavigate } from "react-router-dom";
import{driverFormValidation} from "../validation/Validation";
import Calender from "../components/Calendar";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';

const Driver = ({roleType}) =>{
    const isOfficeAdmin = roleType === 'officeAdmin';
    //alert(roleType);
    const dispatch = useDispatch();
        const loading = useSelector((state) => state.loader.loading);
    let currentInputIndex = 0;
    const navigate = useNavigate();
    //const [loading, setLoading]  = useState(false);
    const [birthDate, setBirthDate] = useState();
    const [hireDate,setHireDate] = useState();
    const [lisenceExpiryDate,setLisenceExpiryDate] = useState();
    const [renewalDate,setRenewalDate] = useState(); 
    const [currentDate,setCurrentDate] = useState(new Date());
    const [stateData, setStateData] = useState([]);
    const formRef  = useRef({});
    const [passengerDetails,setPassengerDetails] = useState([]);
    const [myArray, setMyArray] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [errors,setErrors] = useState({});
    const [driverDetails,setDriverDetails] = useState({
        first_name:'',
        middle_name:'',
        last_name:'',
        preferred_name:'',
        gender:'',
        passengerIds:[],
        ssn_number:'',
        umpi_number:'',
        hire_date:'',
        expiry_date:'',
        renewal_date:'',
        address_line_one:'',
        address_line_two:'',
        state:'',
        zip:'',
        city:'',
        home_phone:'',
        cell_phone:'',
        pick_phone:'',
        alternative_phone:'',
        email_address:'',
        date_of_birth:'',
        e_first_name:'',
        e_last_name:'',
        e_cell_number:'',
        e_email:'',
        u_nme:'',
        u_pswd:'',
        c_pswd:'',
    user_id:'',
    roleType:roleType
    });

        
      
        const inputRef = useRef(null);
          async function handleFormSubmit(e) {
            e.preventDefault();
            const isValid =    driverFormValidation(driverDetails,roleType);
            setErrors(isValid);
            if(Object.keys(isValid).length === 0){
            try {
                 dispatch(setLoading(true));
                const response = await axios.post(ADD_DRIVER_URI, driverDetails);
                
                //console.log(response.data.status);
                if (response.data.status === '200') {
                   dispatch(setLoading(false));
                    navigate('list');
                  
                    // setLoading(false);
                    Swal.fire({
                        title: 'Success!',
                        text: isOfficeAdmin ? "Office Admin added successfully" : response.data.message ,
                        icon: 'success',
                        confirmButtonText: 'OK',
                      });
                    
                } else {
                    dispatch(setLoading(false));
                    Swal.fire({
                        title: 'Error!',
                        text: isOfficeAdmin ? "Office Admin added failed" : response.data.message ,
                        icon: 'Error',
                        confirmButtonText: 'OK',
                      });
                    //console.log(response.data.message);
                }
            } catch (error) {
                 dispatch(setLoading(false));
                console.error("Error logging in:", error);
            }
        }
        }
      
        // const generateInput = (e)=> {
        //     let inputcount = document.getElementsByName('e_name').length+1;
        //     e.preventDefault();
        //     const input = document.createElement('input');
        //     input.type = 'text';
        //     input.setAttribute('data-index',formRef.current.querySelectorAll('.my-3').length);
        //     input.classList.add('form-control', 'my-3');
        //     input.name = 'e_name';
        //     input.setAttribute('autocomplete', 'off'); 
        //     input.id='driver_' + inputcount;
        //     input.addEventListener('keyup', onChangeHandler);
        //     input.addEventListener('change', handleInputChange);
        //     document.getElementById('inputs-section2').appendChild(input);
            
        //   }

          useEffect(() => {
              const loadUser = async ()=>{
                const response_1 = await axios.get(GET_PASSENGER_LIST);
                const response_2 = await axios.get(GET_STATE_URI);
                //console.log("pass",response_1.data);
                setPassengerDetails(response_1.data);
                setStateData(response_2.data);
              }

            loadUser();
          }, []);

   
          const handleInputChange=(e)=>{
            const {name,value}=e.target;
            setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
            setDriverDetails((prev)=>{
                return{
                 ...prev,
                  [name]:value,
                passengerIds:  Array.from(formRef.current.querySelectorAll('.my-3')).map((input) => input.value  ),
               //Ids:  inputRef.current.dataset.code
                }
            });
            
        }
        const handleBeforeInput = (e) => {
            const alphanumericPattern = /^[A-Za-z0-9]*$/;
            if (!alphanumericPattern.test(e.data)) {
              e.preventDefault();
            }
          };
        // const handleHiddenInputChange=(e)=>{
        //     //console.log(formRef.current.querySelectorAll('.user_id'));
        //     setDriverDetails((prev)=>{
        //         return{
        //             ...prev,
        //         userId:  Array.from(formRef.current.querySelectorAll('.user_id')).map((input) => input.value  ),
        //        //Ids:  inputRef.current.dataset.code
        //         }
        //     });
       
        // }
      
        // const onSuggestHandler = (text,id) => {
           
        //     currentInputIndex= localStorage.getItem('InputIndex') || 0;
        //     const passengerDetails=driverDetails.passengerIds.map((value,index)=>{
        //         if(index == currentInputIndex)
        //             { 
        //              return {text,id};}
        //          else{ return value; }
        //     });
            
        //     setMyArray((prevData) => {
        //         return [...prevData, id]; // spread the previous array and add the new id
        //       });
        //       setDriverDetails((prev)=>{
        //         return{
        //          ...prev,
        //         passengerIds:  [...passengerDetails],
        //         userIds: [...myArray, id]
        //         }
                
        //     });
        //       //handleHiddenInputChange();
        //     userSuggestionData(passengerDetails);
        //     setSuggestions([]);
        //   };
          
        //   const userSuggestionData = (passenger)=>{
           
        //      var inputs = document.querySelectorAll('.my-3');
        //         for (var i = 0; i < inputs.length; i++) {
        //             //inputs[i].value = passenger[i] || '';
        //             if (typeof passenger[i] === 'string') {
        //                 inputs[i].value = passenger[i];
        //               } else if (typeof passenger[i] === 'object') {
        //                 inputs[i].value = passenger[i].text || '';
        //               } else {
        //                 inputs[i].value = '';
        //               }
        //         }
        //     }

        //   const onChangeHandler = (e)=>{
        //     console.log('Key up event triggered:', e.target);
        //     let text = e.target.value ? e.target.value : "";
        //     let inputIndex = e.target.dataset.index;
        //     localStorage.setItem('InputIndex',inputIndex);
        //     //console.log( e.target);
        //         let matches = [];
        //         if(text.length > 0){
        //             matches = passengerDetails.filter(user =>{
        //                 const regex = new RegExp(`${text}`,"gi");
        //                 return user.first_name.match(regex) || user.user_id.toString().match(regex);
        //             })
        //         }
        //         setSuggestions(matches);
        //        //console.log(matches);
        //   }
         
return(
    <div className="tab-pane fade active show" id="add-driver" role="tabpanel" aria-labelledby="driver-tab">
        <div className="container-fluid px-mobile-2">

            <section>
                
             <div className='d-flex justify-content-between form-container'>
                <div>
                    <h2 className="fs-5 font-weight-600">{isOfficeAdmin ? 'Add Office Admin' : 'Add Driver'}</h2>
                </div>
                <div>
                    <span >{currentDateFormat(currentDate)}</span>
                </div>
              </div>
            </section>
            <section>
                <div className='bg-white  px-5 py-4'>
                    <div>
                    <p className="pt-2 sub-title">Personal Information</p>
                    </div>
                    <form onSubmit={handleFormSubmit} ref={formRef}>
                        <div className="form-items">
                            <div>
                                <label className='require-field'>First Name</label>
                                <input type="text" autoComplete='off'  className="form-control" id="first_name" name="first_name" placeholder="" onChange={handleInputChange} />
                                {errors.first_name && <span className='errors'>{errors.first_name}</span> }
                            </div>
                            <div>
                                <label>Middle Name</label>
                                <input type="text" autoComplete='off' className="form-control" id="middle_name" name="middle_name" placeholder="" onChange={handleInputChange} />
                            </div>
                            <div>
                                <label className='require-field'>Last Name</label>
                                <input type="text" autoComplete='off' className="form-control" id="last_name" name="last_name" placeholder="" onChange={handleInputChange} />
                                {errors.last_name && <span className='errors'>{errors.last_name}</span> }
                            </div>
                            <div>
                                <label>Preferred Name</label>
                                <input type="text" autoComplete='off' className="form-control" id="preferred_name" name="preferred_name" placeholder="" onChange={handleInputChange} />
                            </div>
                            <div>
                                <label className='require-field'>Gender</label>
                                <div>
                                    <select className="form-select" aria-label="Default select example" name="gender" onChange={handleInputChange}>
                                        <option value="">Select</option>
                                        <option value="1">Male</option>
                                        <option value="2">Female</option>
                                    </select>
                                </div>
                                {errors.gender && <span className='errors'>{errors.gender}</span> }
                            </div>
                            <div className="date-selector">
                                <label className='require-field'>Date of Birth</label>
                                <Calender 
                                selected={birthDate}
                                onChange={handleInputChange}
                                setDate = {setBirthDate}
                                name= "date_of_birth"
                                id= "date_of_birth"
                                isClearable={false}
                                errors={errors.date_of_birth}
                            />
                                
                            </div>
                            <div>
                                <label>SSN</label>
                                <input type="text" autoComplete='off' className="form-control" id="ssn_number" name="ssn_number" onChange={handleInputChange} placeholder="" />
                            </div>
                            <div>
                                <label>UMPI Number</label>
                                <input type="text" autoComplete='off' 
                                className="form-control" 
                                id="umpi_number" 
                                name="umpi_number" 
                                onChange={handleInputChange}
                                 placeholder=""
                                 maxLength="10"
                                 onBeforeInput={handleBeforeInput}
                                  />
                                {errors.umpi_number && <span className='errors'>{errors.umpi_number}</span> }
                            </div>
                            <div>
                                <div className="date-selector grid-span">
                                    <label>Driver License Expiry Date</label>
                                     <Calender 
                                        selected={lisenceExpiryDate}
                                        onChange={handleInputChange}
                                        setDate = {setLisenceExpiryDate}
                                        name= "expiry_date"
                                        id= "expiry_date"
                                        errors={errors.expiry_date}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="date-selector grid-span">
                                    <label>Hire Date</label>
                                     <Calender 
                                        selected={hireDate}
                                        onChange={handleInputChange}
                                        setDate = {setHireDate}
                                        name= "hire_date"
                                        id= "hire_date"
                                        errors={errors.hire_date}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="date-selector grid-span">
                                    <label>Renewal Date</label>
                                    <Calender 
                                        selected={renewalDate}
                                        onChange={handleInputChange}
                                        setDate = {setRenewalDate}
                                        name= "renewal_date"
                                        id= "renewal_date"
                                        errors={errors.renewal_date}
                                    />
                                </div>
                            </div>
                            <div>
                                <label className='require-field'>Address Line 1</label>
                                <input type="text" autoComplete='off' className="form-control" id="address_line_one" name="address_line_one" onChange={handleInputChange} placeholder="" />
                                {errors.address_line_one && <span className='errors'>{errors.address_line_one}</span> }
                            </div>
                            <div>
                                <label>Address Line 2</label>
                                <input type="text" autoComplete='off' className="form-control" id="address_line_two" name="address_line_two" onChange={handleInputChange} placeholder="" />
                            </div>
                            <div>
                                <label className='require-field'>City</label>
                                <input type="text" autoComplete='off' className="form-control" id="city" name="city"  onChange={handleInputChange} />
                                {errors.city && <span className='errors'>{errors.city}</span> }
                            </div>
                            <div>
                                <label className='require-field'>State</label>
                                <select className="form-select" onChange={handleInputChange} aria-label="Default select example" id='state' name="state">
                                <option  value="">Select...</option>
                                    {stateData.map((state, index) => (
                                         <option key={index} value={state.state_id}>{state.state_name}</option>
                                    ))}
                                </select>
                                {errors.state && <span className='errors'>{errors.state}</span> }
                            </div>
                            <div>
                                <label className='require-field'>Zip</label>
                                <input type="text" autoComplete='off' onInput={restrictZipInput} className="form-control" id="zip" name="zip" placeholder="" onChange={handleInputChange} />
                                {errors.zip && <span className='errors'>{errors.zip}</span> }
                            </div>
                            <div>
                                <label >Home Phone Number</label>
                                <InputMask  className="form-control" autoComplete='off' mask="(999) 999-9999"   id="home_phone" name="home_phone" onChange={handleInputChange} ></InputMask>
                                {/* {errors.home_phone && <span className='errors'>{errors.home_phone}</span> } */}
                              </div>
                            <div>
                                <label>Cell Phone Number</label>
                                <InputMask  className="form-control" autoComplete='off' mask="(999) 999-9999"   id="cell_phone" name="cell_phone" onChange={handleInputChange} ></InputMask>
                                {errors.cell_phone && <span className='errors'>{errors.cell_phone}</span> }
                                {/* <div className="form-check pt-2">
                                    <input className="form-check-input" type="checkbox" value="" onChange={handleInputChange} id="pick-up-phone" name="pick_phone" />
                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                        Pick Up Phone
                                    </label>
                                </div> */}
                            </div>
                            <div>
                                <label>Alternate Phone Number</label>
                                <InputMask  className="form-control" autoComplete='off' mask="(999) 999-9999"   id="alternative_phone" name="alternative_phone" onChange={handleInputChange} ></InputMask>
                             </div>
                            <div className="form-item">
                                <label>Email Address</label>
                                <input type="email" autoComplete='off' className="form-control" id="email_address" name="email_address" onChange={handleInputChange} placeholder="" />
                            </div>
                        </div>
                        {/* <div className="my-4">
                        <p className='sub-title'>Emergency Contact Information</p>
                          
                            <div className="form-items">
                                <div>
                                    <label>First Name</label>
                                    <input type="text" autoComplete='off' className="form-control" id="e_first_name" name="e_first_name" onChange={handleInputChange} placeholder="" />
                                </div>
                                <div>
                                    <label>Last Name</label>
                                    <input type="text" autoComplete='off' className="form-control" id="e_last_name" name="e_last_name" onChange={handleInputChange} placeholder="" />
                                </div>
                                <div>
                                    <label>Cell Phone Number</label>
                                    <InputMask  className="form-control" autoComplete='off' mask="(999) 999-9999"   id="e_cell_number" name="e_cell_number" onChange={handleInputChange} ></InputMask>
                                    
                                </div>
                                <div className="form-item">
                                    <label>Email Address</label>
                                    <input type="email" autoComplete='off' className="form-control" id="e_email" name="e_email" onChange={handleInputChange} placeholder="" />
                                </div>
                            </div>
                        </div> */}
                        {
                        isOfficeAdmin && (
                            <div className="py-3">
                                <label>&nbsp;</label>
                                <div className="form-check">
                                    <input 
                                        type="checkbox" 
                                        className="form-check-input" 
                                        name="is_driver" 
                                        id="is_driver" 
                                        onChange={handleInputChange} 
                                    />
                                    <label className="form-check-label" htmlFor="is_driver">
                                        Mark as Driver
                                    </label>
                                </div>
                            </div>
                        )
                       }
                        <div className="py-3">
                        <p className='sub-title'> Login Credentials</p>
                            <div className="form-items">
                            <ConfirmPasswordNormal  handleInputChange={handleInputChange} errors={errors}  />
                                
                            </div>
                        </div>
                      
                        <div className='footer-content'>
                        <SaveButton type='submit' buttonTitle={isOfficeAdmin ? 'ADD OFFICE ADMIN' : 'ADD DRIVER'}/>

                            {/* <CancelButton cancelHandler={() => navigate('list')} /> */}
                    </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
);
}
export default Driver;